<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Proveedores</h1>
    <div class="mb-6 flex justify-between items-center">

    </div>
     <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Empresa</th>
          <th class="px-6 pt-6 pb-4">N° Fact</th>
          <th class="px-6 pt-6 pb-4">Fecha Creado</th>
          <th class="px-6 pt-6 pb-4">Total</th>
          <th class="px-6 pt-6 pb-4">Saldo</th>
          <th class="px-6 pt-6 pb-4">Ruc</th>
          <th class="px-6 pt-6 pb-4">Nombre</th>

        </tr>
        <tr v-for="proveedor in proveedores" :key="proveedor.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4 flex items-center">
            {{ proveedor.Empresa }}
           </td>
           <td class="border-t">
                {{ proveedor.Numero }}
             </td>
          <td class="border-t">
                {{ proveedor.FechaIngreso }}
             </td>
          <td class="border-t">
              {{  proveedor.Total }}
            </td>
          <td class="border-t">
              {{  proveedor.Saldo }}
          </td>
          <td class="border-t">
            {{ proveedor.Ruc }}
           </td>
          <td class="border-t">
            {{  proveedor.Nombre }}
           </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('fpendientes.edit', proveedor.Ruc)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="proveedores.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Proveedores</td>
        </tr>
      </table>
      
    </div>
    <pagination class="mt-6" :links="proveedores.links" />
    <br><br><br>
    <center><h3>Suma Total <b>{{ suma }} </b></h3></center>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'fpendientes' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    suma: Object,
    proveedores: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('fpendientes'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
